import { createSlice, current } from '@reduxjs/toolkit';

export const APP_LANGUAGE = Object.freeze({
  ENGLISH: 'English',
  GEORGIAN: 'Georgian',
  RUSSIAN: 'Russian'
});

const INITAL_STATE = {
  languages: [
    { lang: APP_LANGUAGE.ENGLISH, lang_code: 'en', flag:"🇺🇸" },
    { lang: APP_LANGUAGE.GEORGIAN, lang_code: 'ka', flag:"🇬🇪" }
    // { lang: APP_LANGUAGE.RUSSIAN, lang_code: 'ru', flag:"🇷🇺" }
  ],
  currentLanguage: "en"
};

const languageSlice = createSlice({
    name:"language",
    initialState:INITAL_STATE,
    reducers:{
        setCurrentLanguage:(state, action) => {
            state.currentLanguage = action.payload
        }
    }
})

export const { setCurrentLanguage } = languageSlice.actions
export default languageSlice.reducer